import React from "react";
import PropTypes from "prop-types";

const SvgIcon = ({
  src,
  mobileSrc,
  onClickFn,
  onMouseEnterFn,
  onMouseLeaveFn,
  noFilterOnLight,
  classNames = "",
  ...props
}) => {
  return (
    <picture
      onClick={(e) => (onClickFn ? onClickFn(e) : null)}
      onMouseEnter={(e) => (onMouseEnterFn ? onMouseEnterFn(e) : null)}
      onMouseLeave={(e) => (onMouseLeaveFn ? onMouseLeaveFn(e) : null)}
      {...props}
      className={classNames}
    >
      <img
        className={`${
          noFilterOnLight === true ? "!filter-none" : undefined
        } mobile-hidden`}
        src={src}
      />
      <img
        className={`${
          noFilterOnLight === true ? "!filter-none" : undefined
        } only-show-mobile`}
        src={mobileSrc || src}
      />
    </picture>
  );
};
SvgIcon.contextTypes = {
  locals: PropTypes.object,
  onMouseEnterFn: PropTypes.func,
  onMouseLeaveFn: PropTypes.func,
  onClickFn: PropTypes.func,
  src: PropTypes.string,
  mobileSrc: PropTypes.string,
  noFilterOnLight: PropTypes.bool,
  classNames: PropTypes.string,
};
export default SvgIcon;
